/* TickTalk cart discount controller.
 * Uses a standard delegated listener so Safari never falls back to native form submission.
 */
// Safari-safe cart discount controller: register before customized built-ins.
document.documentElement.dataset.cartDiscountFix = 'loaded-v5';
window.__tickTalkCartDiscountExternal = true;
// Keep the floating Google Store badge away from the cart purchase flow.
(function () {
  const style = document.createElement('style');
  style.id = 'ticktalk-cart-store-badge-visibility';
  style.textContent = [
    'html.tt-hide-google-store-badge #___ratingbadge_0',
    'html.tt-hide-google-store-badge [id*="ratingbadge"]',
    'html.tt-hide-google-store-badge [id*="merchantwidget"]',
    'html.tt-hide-google-store-badge [class*="merchantwidget"]',
    'html.tt-hide-google-store-badge iframe[src*="shopping/customerreviews"]',
    'html.tt-hide-google-store-badge iframe[src*="merchantwidget"]',
    'html.tt-hide-google-store-badge iframe[src*="merchant-badge"]'
  ].join(',') + '{display:none!important;visibility:hidden!important;pointer-events:none!important;}' +
    '@media(max-width:749px){' +
    [
      'html.tt-raise-google-store-badge #google-merchantwidget-iframe-wrapper',
      'html.tt-raise-google-store-badge #___ratingbadge_0'
    ].join(',') +
    '{bottom:calc(var(--tt6-sticky-buy-height,108px) + 16px)!important;top:auto!important;}' +
    '}';
  document.head.appendChild(style);

  function syncStoreBadgeVisibility() {
    const html = document.documentElement;
    const onCartPage = window.location.pathname === '/cart';
    const cartDrawerOpen = document.getElementById('CartDrawer')?.hasAttribute('open') === true;
    const onTickTalk6Product = window.location.pathname === '/products/ticktalk-6';
    const mobileViewport = window.matchMedia('(max-width: 749px)').matches;
    const stickyBuyBar = onTickTalk6Product ? document.querySelector('.tt6-sticky') : null;
    const stickyBuyBarHeight = mobileViewport && stickyBuyBar && window.getComputedStyle(stickyBuyBar).display !== 'none'
      ? Math.ceil(stickyBuyBar.getBoundingClientRect().height)
      : 0;

    html.classList.toggle('tt-hide-google-store-badge', onCartPage || cartDrawerOpen);
    html.classList.toggle('tt-raise-google-store-badge', stickyBuyBarHeight > 0);

    if (stickyBuyBarHeight > 0) {
      html.style.setProperty('--tt6-sticky-buy-height', `${stickyBuyBarHeight}px`);
    } else {
      html.style.removeProperty('--tt6-sticky-buy-height');
    }

    document.querySelectorAll('#google-merchantwidget-iframe-wrapper, #___ratingbadge_0').forEach((badge) => {
      if (badge.dataset.ttOriginalBottomCaptured !== 'true') {
        badge.dataset.ttOriginalBottom = badge.style.getPropertyValue('bottom');
        badge.dataset.ttOriginalBottomPriority = badge.style.getPropertyPriority('bottom');
        badge.dataset.ttOriginalBottomCaptured = 'true';
      }

      if (stickyBuyBarHeight > 0) {
        badge.style.setProperty('bottom', `${stickyBuyBarHeight + 16}px`, 'important');
      } else if (badge.dataset.ttOriginalBottom) {
        badge.style.setProperty(
          'bottom',
          badge.dataset.ttOriginalBottom,
          badge.dataset.ttOriginalBottomPriority || ''
        );
      } else {
        badge.style.removeProperty('bottom');
      }
    });
  }

  let storeBadgeVisibilityFrame;
  function scheduleStoreBadgeVisibility() {
    cancelAnimationFrame(storeBadgeVisibilityFrame);
    storeBadgeVisibilityFrame = requestAnimationFrame(() => {
      storeBadgeVisibilityFrame = requestAnimationFrame(syncStoreBadgeVisibility);
    });
  }

  function startStoreBadgeVisibility() {
    scheduleStoreBadgeVisibility();
    const cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      new MutationObserver(scheduleStoreBadgeVisibility).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    new MutationObserver((mutations) => {
      const badgeAdded = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node instanceof Element && (
            node.matches('#google-merchantwidget-iframe-wrapper, #___ratingbadge_0') ||
            node.querySelector('#google-merchantwidget-iframe-wrapper, #___ratingbadge_0')
          )
        )
      );
      if (badgeAdded) scheduleStoreBadgeVisibility();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startStoreBadgeVisibility, { once: true });
  } else {
    startStoreBadgeVisibility();
  }
  window.addEventListener('pageshow', scheduleStoreBadgeVisibility);
  window.addEventListener('scroll', scheduleStoreBadgeVisibility, { passive: true });
  window.addEventListener('resize', scheduleStoreBadgeVisibility);
})();


  const discountAbortControllers = new WeakMap();

  function existingDiscounts(form) {
    return Array.from(form.querySelectorAll('button[is="discount-remove"][data-discount]'))
      .map((button) => button.getAttribute('data-discount'))
      .filter(Boolean);
  }

  function setDiscountError(form, error) {
    const resultsElement = form.lastElementChild;
    const messageElement = resultsElement?.lastElementChild;
    if (!resultsElement || !messageElement) return;

    messageElement.textContent = error;
    resultsElement.hidden = error.length === 0;
  }

  function abortPendingDiscountRequest(form) {
    discountAbortControllers.get(form)?.abort();
    const controller = new AbortController();
    discountAbortControllers.set(form, controller);
    return controller;
  }

  function applyDiscount(form) {
    const discountCode = form.querySelector('[name="discount"]');
    const submitButton = form.querySelector('[data-cart-discount-apply], [type="submit"]');
    const sectionId = form.getAttribute('data-section-id');

    if (!(discountCode instanceof HTMLInputElement) || !(submitButton instanceof HTMLElement) || !sectionId) return;

    const discountCodeValue = discountCode.value.trim();
    if (discountCodeValue === '') return;

    const currentDiscounts = existingDiscounts(form);
    if (currentDiscounts.includes(discountCodeValue) || submitButton.getAttribute('aria-busy') === 'true') return;

    const controller = abortPendingDiscountRequest(form);
    setDiscountError(form, '');
    submitButton.setAttribute('aria-busy', 'true');

    const body = JSON.stringify({
      discount: [...currentDiscounts, discountCodeValue].join(','),
      sections: [sectionId]
    });

    fetch(theme.routes.cart_update_url, {
      ...theme.utils.fetchConfig('json'),
      body,
      signal: controller.signal
    })
      .then((response) => response.json())
      .then((parsedState) => {
        const discountCodes = parsedState.discount_codes || [];
        const submittedDiscount = discountCodes.find(
          (discount) => discount.code?.toLowerCase() === discountCodeValue.toLowerCase()
        );

        if (!submittedDiscount || submittedDiscount.applicable === false) {
          discountCode.value = '';
          setDiscountError(form, theme.discountStrings.error);
          return;
        }

        const newHtml = parsedState.sections?.[sectionId];
        if (newHtml) {
          const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
          const section = parsedHtml.getElementById(`shopify-section-${sectionId}`);
          const returnedCodes = Array.from(section?.querySelectorAll('button[is="discount-remove"]') || [])
            .map((button) => button.getAttribute('data-discount'))
            .filter(Boolean);

          if (
            returnedCodes.length === currentDiscounts.length &&
            returnedCodes.every((code) => currentDiscounts.includes(code)) &&
            discountCodes.some(
              (discount) => discount.code === discountCodeValue && discount.applicable === true
            )
          ) {
            discountCode.value = '';
            setDiscountError(form, '');
            return;
          }
        }

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-discount',
          cart: parsedState
        });
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error(error);
      })
      .finally(() => {
        submitButton.removeAttribute('aria-busy');
      });
  }

  window.tickTalkApplyCartDiscount = function (button) {
    const container = button?.closest?.('[data-cart-discount], form[is="cart-discount"]');
    if (container instanceof HTMLElement) applyDiscount(container);
    return false;
  };

  function removeDiscount(form, button) {
    const discountCode = button.getAttribute('data-discount');
    if (!discountCode) return;

    const currentDiscounts = existingDiscounts(form);
    const index = currentDiscounts.indexOf(discountCode);
    if (index === -1) return;
    currentDiscounts.splice(index, 1);

    const sectionId = form.getAttribute('data-section-id');
    if (!sectionId) return;

    const controller = abortPendingDiscountRequest(form);
    setDiscountError(form, '');
    button.setAttribute('loading', '');

    const body = JSON.stringify({
      discount: currentDiscounts.join(','),
      sections: [sectionId]
    });

    fetch(theme.routes.cart_update_url, {
      ...theme.utils.fetchConfig('json'),
      body,
      signal: controller.signal
    })
      .then((response) => response.json())
      .then((parsedState) => {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-discount',
          cart: parsedState
        });
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error(error);
      })
      .finally(() => {
        button.removeAttribute('loading');
      });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[is="cart-discount"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      applyDiscount(form);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const submitButton = target.closest('[data-cart-discount] [data-cart-discount-apply], form[is="cart-discount"] [type="submit"]');
      if (submitButton instanceof HTMLElement) {
        const form = submitButton.closest('[data-cart-discount], form[is="cart-discount"]');
        if (form instanceof HTMLElement) {
          event.preventDefault();
          event.stopImmediatePropagation();
          applyDiscount(form);
        }
        return;
      }

      const removeButton = target.closest('button[is="discount-remove"]');
      if (!(removeButton instanceof HTMLButtonElement)) return;

      const form = removeButton.closest('[data-cart-discount], form[is="cart-discount"]');
      if (!(form instanceof HTMLElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      removeDiscount(form, removeButton);
    },
    true
  );

